import { IconType } from "react-icons";
import {
  LuLayoutDashboard,
  LuMegaphone,
  LuMessagesSquare,
  LuUsers,
  LuWallet,
} from "react-icons/lu";
import { SITELINKS } from "../../app-routes/links";

export type NavChild = {
  label: string;
  /** page path, without query string */
  to: string;
  /** ?status= value; "" means the "All" view; undefined means no status filter */
  status?: string;
};

export type NavItem = {
  label: string;
  icon: IconType;
  /** single link (no submenu) */
  to?: string;
  children?: NavChild[];
};

const withStatus = (to: string, items: [string, string][]): NavChild[] =>
  items.map(([label, status]) => ({ label, to, status }));

// Status values must match what each page's API filter expects
export const NAV_ITEMS: NavItem[] = [
  { label: "Dashboard", icon: LuLayoutDashboard, to: SITELINKS.DASHBOARD },
  {
    label: "Users",
    icon: LuUsers,
    children: withStatus(SITELINKS.ELITE_USER, [
      ["All users", ""],
      ["Pending", "PENDING"],
      ["Active", "ACTIVE"],
      ["Flagged", "FLAGGED"],
      ["Removed", "REMOVED"],
    ]),
  },
  {
    label: "Transactions",
    icon: LuWallet,
    children: withStatus(SITELINKS.TRANSACTIONS, [
      ["All transactions", ""],
      ["Pending", "PENDING"],
      ["Failed", "FAILED"],
      ["Paid", "PAID"],
    ]),
  },
  {
    label: "Requests",
    icon: LuMessagesSquare,
    children: withStatus(SITELINKS.REQUEST, [
      ["All requests", ""],
      ["Pending", "pending"],
      ["Accepted", "accepted"],
      ["Rejected", "rejected"],
      ["Closed", "closed"],
    ]),
  },
  {
    label: "Broadcast",
    icon: LuMegaphone,
    children: [
      { label: "New broadcast", to: SITELINKS.BROADCAST },
      { label: "History", to: SITELINKS.BROADCAST_HISTORY },
    ],
  },
];

export const childHref = (c: NavChild) =>
  c.status ? `${c.to}?status=${encodeURIComponent(c.status)}` : c.to;
